import { Injectable } from '@angular/core';
import {
    HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class ServerDownInterceptor implements HttpInterceptor {
    constructor(private router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                const currentUrl = this.router.url;
                if (
                    (error.status === 502 || error.status === 503 || error.status === 504) &&
                    !currentUrl.startsWith('/dashboard/under-maintenance') &&
                    !currentUrl.startsWith('/login') &&
                    !currentUrl.startsWith('/register')
                ) {
                    this.router.navigate(['/dashboard/under-maintenance']);
                }
                return throwError(() => error);
            })
        );
    }
}
